import styled from 'styled-components';
import { asRem } from 'utils';
import { breakpoints, colors } from 'components/Theme';
import { Card } from 'Component';

export default styled(Card)`
  color: ${colors.white.c500};
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: ${asRem(460)};
  max-height: ${asRem(570)};

  @media (min-width: ${breakpoints.md}) {
    height: ${asRem(550)};
  }

  .course-image {
    aspect-ratio: ${asRem(1306)} / ${asRem(158)};
    align-self: center;
    margin-bottom: ${asRem(16)};
    height: ${asRem(160)};

    @media (min-width: ${breakpoints.md}) {
      height: ${asRem(170)};
    }
  }

  .course-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
  }

  .course-text {
    flex-grow: 1;
    text-align: center;
  }

  .course-tag {
    margin-bottom: -${asRem(16)};
  }

  .course-title {
    line-height: 1.5;
  }

  .course-description {
    margin-bottom: ${asRem(8)};
    @media (min-width: ${breakpoints.md}) {
      margin-bottom: ${asRem(32)};
    }
  }

  .button-wrapper {
    display: flex;
    justify-content: center;
    margin-top: auto;
    padding-bottom: ${asRem(16)};
  }

  .course-button {
    width: 100%;

    @media (min-width: ${breakpoints.md}) {
      width: 85%;
    }

    @media (min-width: ${breakpoints.lg}) {
      width: 90%;
    }

    @media (min-width: ${breakpoints.xl}) {
      width: 100%;
    }
  }

  &.pink500 {
    background-color: ${colors.pink.c500};
  }

  &.blue500 {
    background-color: ${colors.blue.c500};
  }
`;
